"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var REATOA = REATOA || {
  data: {
    url: '',
    $body: $('body'),
    $window: $(window),
    $MQ: 'LANDSCAPE',
    scrollTop: 0,
    lockTop: 0,
    winW: '',
    winH: '',
    jqXHR: '',
    scrollTopflag: false,
    transitonEnd: 'webkitTransitionEnd mozTransitionEnd msTransitionEnd oTransitionEnd transitionend',
    animationStart: 'webkitAnimationStart mozAnimationStart msAnimationStart oAnimationStart animationStart',
    animationEnd: 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd',
    isTouch: false
  },
  common: {
    init: {}
  }
};
REATOA.common = function (pageScript) {
  // コンストラクタ  =================================================================
  function init(pageScript) {
    setUtilityData();
    setBrowser();
    $('[data-pulldown-trigger]')[0] && initPulldown();
    $('[data-nav-trigger]')[0] && initNavTrigger();
    $('.js-anchorLink')[0] && initAnchorLink();
    $('.js-hamburgerIcon')[0] && initHamburgerMenu();
    $('.js-wildcraftSection')[0] && initWildcraftParallax();
    $('.js-promoBanner')[0] && initPromoBanner();
    initCustomCursor();
    pageScript && pageScript();
  }

  // public functions  ==========================================================
  /*
  *   UtilityDataの取得
  *   特定ページのみで使用するデータはページJSで取得すること。
  *
  */
  function setUtilityData() {
    REATOA.data.url = window.location.pathname;
    getScrollTop();
    REATOA.data.$window.on('scroll', getScrollTop);
    getWindowSize();
    REATOA.data.$window.on('resize', function () {
      getWindowSize();
    });
  }
  var scrollFlag = false;
  function getScrollTop() {
    if (!scrollFlag) {
      requestAnimationFrame(function () {
        scrollFlag = false;
        REATOA.data.$window.trigger('scroll.custom');
        REATOA.data.scrollTop = REATOA.data.$window.scrollTop();
      });
      scrollFlag = true;
    }
    return true;
  }
  function getWindowSize() {
    REATOA.data.winW = REATOA.data.$window.width();
    REATOA.data.winH = REATOA.data.$window.height();
    var cssContent = $('body').css('content');
    if (cssContent.indexOf('portrait') != -1) {
      REATOA.data.$MQ = 'PORTRAIT';
    } else {
      REATOA.data.$MQ = 'LANDSCAPE';
    }
    if (REATOA.data.oldMQ && REATOA.data.oldMQ !== REATOA.data.$MQ) {
      REATOA.data.$window.trigger('onBreakpointChange');
    }
    REATOA.data.oldMQ = REATOA.data.$MQ;
  }
  // HO TO USE
  // REATOA.data.$window.on('onBreakpointChange', 実行文);

  /*
  *
  *  ブラウザ判定
  *
  */
  function setBrowser() {
    REATOA.data.ua = {
      Safari: typeof window.chrome == 'undefined' && 'WebkitAppearance' in document.documentElement.style,
      Firefox: 'MozAppearance' in document.documentElement.style,
      IE: window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 || window.navigator.userAgent.toLowerCase().indexOf('trident') !== -1,
      IE9: window.navigator.appVersion.toLowerCase().indexOf('msie 9.') !== -1,
      ltIE9: typeof window.addEventListener === 'undefined' && typeof document.getElementsByClassName === 'undefined',
      Touch: typeof document.ontouchstart !== 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled,
      Windows: window.navigator.userAgent.toLowerCase().indexOf('win') !== -1,
      Mac: window.navigator.userAgent.toLowerCase().indexOf('mac') !== -1,
      Mobile: window.navigator.userAgent.toLowerCase().indexOf('iphone') > 0 || window.navigator.userAgent.toLowerCase().indexOf('ipod') > 0 || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') > 0,
      Tablet: window.navigator.userAgent.toLowerCase().indexOf('ipad') > 0 || window.navigator.userAgent.toLowerCase().indexOf('macintosh') > 0 && 'ontouchend' in document || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') == -1
    };

    // タッチデバイス判定フラグを設定
    REATOA.data.isTouch = REATOA.data.ua.Touch || REATOA.data.ua.Mobile || REATOA.data.ua.Tablet;
    if (REATOA.data.ua.Safari) {
      $('html').addClass('safari');
    }
    if (REATOA.data.ua.Firefox) {
      $('html').addClass('firefox');
    }
    if (REATOA.data.ua.IE) {
      $('html').addClass('ie');
    }
    if (REATOA.data.ua.IE9) {
      $('html').addClass('ie9');
    }
    if (REATOA.data.ua.ltIE9) {
      $('html').addClass('ie8');
    }
    if (REATOA.data.ua.Tablet) {
      $('html').addClass('tablet');
    }
    if (REATOA.data.isTouch) {
      $('html').addClass('is-touch');
    }
  }

  // event functions  =================================================================
  /*
  *
  *  アンカーリンク
  *
  */
  function initAnchorLink() {
    $('.js-anchorLink').on('click', function () {
      var href = $(this).attr("href"),
        target = $(href === "#" || href === "" ? 'html' : href),
        offset = target.offset().top;
      $('html, body').animate({
        scrollTop: offset
      }, 500);
      return false;
    });
  }

  /*
  *
  *  ヘッダー内のナビゲーショントリガー
  *
  */
  function initNavTrigger() {
    if (!REATOA.data.isTouch) return;
    $('[data-nav-trigger]').on('click', function (e) {
      console.log('click');
      e.preventDefault();
      var triggerValue = $(this).data('nav-trigger');
      var $target = $("[data-nav-target=\"".concat(triggerValue, "\"]"));
      if ($target.is(':animated')) return;
      if ($target.length) {
        $target.toggleClass('is-open');
      }
    });
  }

  /*
  *
  *  プルダウン
  *
  */
  function initPulldown() {
    $('[data-pulldown-trigger]').each(function () {
      var pulldown = new Pulldown($(this));
      pulldown.init();
    });
  }
  var Pulldown = /*#__PURE__*/function () {
    function Pulldown(trigger) {
      _classCallCheck(this, Pulldown);
      this.trigger = trigger;
      this.target = $("[data-pulldown-target=\"".concat(this.trigger.data('pulldown-trigger'), "\""));
      this.openClass = 'is-open';
    }
    return _createClass(Pulldown, [{
      key: "init",
      value: function init() {
        var _this = this;
        this.trigger.on('click', function () {
          if (REATOA.data.$MQ === 'LANDSCAPE' && _this.trigger.data('pulldown-trigger').indexOf('eci10rule_') !== -1) return;
          _this.toggleEvent();
        });
      }
    }, {
      key: "toggleEvent",
      value: function toggleEvent() {
        if (this.target.is(':animated')) return;
        this.trigger.toggleClass(this.openClass);
        this.target.slideToggle(500);
      }
    }]);
  }(); // ページごと読み込み event functions  ==========================================================
  /*
  *
  *
  *   ストレージ set・get
  *
  */
  // セッションストレージ - セット
  function setSessionStrage(key, value) {
    if (!window.sessionStorage) return;
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {}
  }
  // ローカルストレージ - セット
  function setLocalStrage(key, value) {
    if (!window.localStorage) return;
    try {
      localStorage.setItem(key, value);
    } catch (err) {}
  }
  // セッションストレージ - ゲット
  function getSessionStrage(targetStrage) {
    var strage;
    if (!window.sessionStorage) return;
    try {
      strage = window.sessionStorage.getItem(targetStrage);
    } catch (err) {}
    return strage;
  }
  // ローカルストレージ - ゲット
  function getLocalStrage(targetStrage) {
    var strage;
    if (!window.localStorage) return;
    try {
      strage = window.localStorage.getItem(targetStrage);
    } catch (err) {}
    return strage;
  }

  /*
  *
  *   画像読み込み数カウンタ
  *   @target - jQueryオブジェクトで指定。指定された要素内のimgのロードを監視する。
  *   promiseを返すので、戻り値に対して.doneでコールバックを実装する。
  */
  function countImgLoaded(target, runnninng) {
    var deferred = new $.Deferred();
    var $img = target ? target.find('img') : $('img');
    var total = $img.length;
    var count = 0;
    $img.each(function () {
      var myImg = new Image();
      myImg.src = $(this).attr('src');
      myImg.onload = function () {
        count++;
        var progress = count / total;
        if (runnninng) {
          runnninng(progress);
        }
        if (count >= total) {
          deferred.resolve();
        }
      };
      myImg.onerror = function () {
        deferred.reject();
      };
    });
    return deferred.promise();
  }

  /*
  * スクロールロック
  *
  */
  function screenLock() {
    $('html').addClass('scrollLock');
  }
  ;
  function screenUnlock() {
    $('html').removeClass('scrollLock');
  }
  ;
  function initHamburgerMenu() {
    var hamburgerIcon = $('.js-hamburgerIcon');
    hamburgerIcon.on('click', function () {
      if (REATOA.data.$body.hasClass('is-hamburgerMenuOpen')) {
        REATOA.common.screenUnlock();
        REATOA.data.$body.removeClass('is-hamburgerMenuOpen');
      } else {
        REATOA.common.screenLock();
        REATOA.data.$body.addClass('is-hamburgerMenuOpen');
      }
    });
  }

  /*
  *
  *  Wildcraft パララックス（純粋なJavaScript実装）
  *
  */
  function initWildcraftParallax() {
    var section = document.querySelector('.js-wildcraftSection');
    var bg = document.querySelector('.js-wildcraftSectionBg');
    if (!section || !bg) return;

    // パフォーマンス最適化のためのCSS設定
    bg.style.willChange = 'transform';
    function updateParallax() {
      var rect = section.getBoundingClientRect();
      var windowHeight = REATOA.data.winH;

      // セクションが画面内にある場合のみ処理
      if (rect.bottom > 0 && rect.top < windowHeight) {
        // スクロール進行度を計算（0〜1）
        var sectionHeight = rect.height;
        var scrollProgress = (windowHeight - rect.top) / (windowHeight + sectionHeight);

        // デバイスに応じて動きを調整
        var moveDistance = REATOA.data.$MQ === 'LANDSCAPE' ? 0.25 : 0.35;

        // パララックス効果の計算（-50%基準で上下に動く）
        var translateY = -50 + scrollProgress * moveDistance * 100;

        // transform適用（GPU加速）
        bg.style.transform = "translate3d(0, ".concat(translateY, "%, 0)");
      }
    }

    // 初期位置設定
    bg.style.transform = 'translate3d(0, -50%, 0)';

    // 既存のカスタムスクロールイベントを使用（requestAnimationFrame済み）
    REATOA.data.$window.on('scroll.custom', updateParallax);

    // 画像読み込み完了後に一度実行
    var img = bg.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener('load', updateParallax, {
        once: true
      });
    } else {
      updateParallax();
    }

    // ブレークポイント変更時とリサイズ時に再計算
    REATOA.data.$window.on('onBreakpointChange resize', updateParallax);
  }

  /*
  *   プロモーションバナーの閉じる機能
  *   localStorageを使用して閉じた状態を保持
  *   初期状態は非表示、閉じられていない場合のみ表示
  *
  */
  function initPromoBanner() {
    var $banner = $('.js-promoBanner');
    if (!$banner.length) return;
    var bannerId = $banner.data('banner-id');
    var storageKey = "promoBanner_".concat(bannerId, "_closed");

    // 閉じられていない場合は表示する
    if (REATOA.common.getSessionStrage(storageKey) !== 'true') {
      // 少し遅延させてからis-hiddenを削除（CSSアニメーションを効かせるため）
      setTimeout(function () {
        $banner.removeClass('is-hidden');
      }, 100);
    }

    // 閉じるボタンのクリックイベント
    $('.js-promoBanner_close').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $closeBtn = $(this);
      $banner.addClass('is-hidden');

      // sessionStorageに保存
      REATOA.common.setSessionStrage(storageKey, 'true');

      // アニメーション完了後にDOMから削除
      setTimeout(function () {
        $banner.remove();
        $closeBtn.remove();
      }, 300);
    });
  }

  /*
  *   カスタムカーソル
  *   PC時のみ、カスタムカーソルを表示
  *   通常時：10px × 10pxの白い正円、mix-blend-mode: difference
  *   ホバー時：クリック可能な要素で100px × 100pxに拡大
  *   参考: https://crosset.onward.co.jp/feature/originals2025aw-next-trad/
  *
  */
  function initCustomCursor() {
    // ポインターデバイス（ホバー可能なデバイス）のみで動作
    var isPointerDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isPointerDevice) return;

    // カーソル要素を作成
    var $cursor = $('<div class="customCursor"></div>');
    REATOA.data.$body.append($cursor);

    // 初期位置を設定
    $cursor.css('transform', 'translate(50vw, 50vh)');

    // マウス移動でカーソル位置を更新
    $(document).on('mousemove', function (e) {
      $cursor.css('transform', "translate(".concat(e.clientX, "px, ").concat(e.clientY, "px)"));
    });

    // クリック可能な要素にホバーした時に拡大
    var clickableSelectors = 'a, button, input, select, textarea, [role="button"], [onclick], .js-hamburgerIcon, [data-pulldown-trigger]';
    $(document).on('mouseenter', clickableSelectors, function () {
      if (REATOA.data.$MQ === 'LANDSCAPE') {
        $cursor.addClass('is-hover');
      }
    });
    $(document).on('mouseleave', clickableSelectors, function () {
      $cursor.removeClass('is-hover');
    });

    // ページ読み込み後にカーソルを表示
    setTimeout(function () {
      $cursor.addClass('is-visible');
    }, 100);

    // マウスがページ外に出た時の処理
    $(document).on('mouseleave', function () {
      $cursor.removeClass('is-visible');
    });
    $(document).on('mouseenter', function () {
      if (REATOA.data.$MQ === 'LANDSCAPE') {
        $cursor.addClass('is-visible');
      }
    });

    // ブレークポイント変更時の処理
    REATOA.data.$window.on('onBreakpointChange', function () {
      if (REATOA.data.$MQ === 'PORTRAIT') {
        $cursor.removeClass('is-visible is-hover');
      } else {
        $cursor.addClass('is-visible');
      }
    });
  }
  return {
    setSessionStrage: setSessionStrage,
    setLocalStrage: setLocalStrage,
    getSessionStrage: getSessionStrage,
    getLocalStrage: getLocalStrage,
    countImgLoaded: countImgLoaded,
    screenLock: screenLock,
    screenUnlock: screenUnlock,
    init: init
  };
}();